import dayjs from "dayjs";

import dateTimeService from "app/services/date-time/dateTimeService";
import type { RawDate } from "app/UtilitiesAndConstants/types/dates";

const MIN_PERCENTAGE_QUOTA = 0.2;

const DEFAULT_MAX_OPTION_VALUE = 0;
const DEFAULT_PRICE_PER_RECORD = 0;

export const shouldDisableRecentCompany = (date: RawDate): boolean => {
    const isInCurrentMonth = dateTimeService.getUTCMoment(date).isSame(dayjs.utc(), "month");

    return !isInCurrentMonth;
};

export const isLessThanMinQuota = (totalQuota: number, remainingQuota: number): boolean => {
    if (totalQuota <= 0) {
        return false;
    }

    return remainingQuota / totalQuota <= MIN_PERCENTAGE_QUOTA;
};

export const cannotAffordAnyOption = (
    remainingQuota: number,
    pricePerRecord: number,
    maxOptionValue: number = DEFAULT_MAX_OPTION_VALUE,
): boolean => {
    if (pricePerRecord <= 0) {
        return false;
    }

    return remainingQuota < maxOptionValue * pricePerRecord;
};

type LowCreditCheckParams = {
    totalQuota: number;
    remainingQuota: number;
    pricePerRecord?: number;
    maxOptionValue?: number;
    isNoTouchUser: boolean;
};

export const shouldShowLowCreditsBanner = (params: LowCreditCheckParams): boolean => {
    const {
        totalQuota,
        remainingQuota,
        pricePerRecord = DEFAULT_PRICE_PER_RECORD,
        maxOptionValue,
        isNoTouchUser,
    } = params;

    if (isNoTouchUser) {
        if (pricePerRecord <= 0) {
            return isLessThanMinQuota(totalQuota, remainingQuota);
        }

        return cannotAffordAnyOption(remainingQuota, pricePerRecord, maxOptionValue);
    }

    // All other users: percentage-based threshold
    return isLessThanMinQuota(totalQuota, remainingQuota);
};
